import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type UpdateIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const UpdateIcon = ({ strokeWidth, ...props }: UpdateIconProps) => (
  <BaseIcon width="15" height="16" viewBox="0 0 15 16" fill="none" strokeWidth={strokeWidth} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.43267 2.84953C8.31879 2.43146 7.09939 2.38585 5.95739 2.71954C4.8154 3.05323 3.8124 3.74824 3.09888 4.70028C2.38535 5.65232 1.99978 6.81006 2 7.99981L1.30501e-07 8.00018C-0.000302423 6.3778 0.525482 4.79906 1.49847 3.50082C2.47146 2.20258 3.83918 1.25485 5.39645 0.799818C6.95371 0.344782 8.61654 0.406977 10.1355 0.977073C11.6544 1.54717 12.9475 2.59442 13.8208 3.96172L12.1352 5.03827C11.4948 4.03559 10.5465 3.2676 9.43267 2.84953Z"
      fill="#141B4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4.5V1.5H15V5.5C15 6.05228 14.5523 6.5 14 6.5H10V4.5H13Z"
      fill="#141B4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9016 11.2997C12.6151 10.3476 13.0007 9.18988 13.0005 8.00013L15.0005 7.99976C15.0008 9.62214 14.475 11.2009 13.502 12.4991C12.529 13.7974 11.1613 14.7451 9.60401 15.2001C8.04675 15.6552 6.38392 15.593 4.865 15.0229C3.34608 14.4528 2.05298 13.4055 1.17969 12.0382L2.86523 10.9617C3.50564 11.9643 4.45391 12.7323 5.56779 13.1504C6.68166 13.5685 7.90107 13.6141 9.04306 13.2804C10.1851 12.9467 11.1881 12.2517 11.9016 11.2997Z"
      fill="#141B4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10.4998C0 9.94747 0.447715 9.49976 1 9.49976H5V11.4998H2V14.4998H0V10.4998Z"
      fill="#141B4D"
    />
  </BaseIcon>
);

UpdateIcon.displayName = 'UpdateIcon';
